import { ReflectUtils } from "@dooboostore/core";
import { ObjectUtils } from "@dooboostore/core";
var ExceptionHandlerSituationType = /* @__PURE__ */ ((ExceptionHandlerSituationType2) => {
  ExceptionHandlerSituationType2["ERROR_OBJECT"] = "SIMPLE_BOOT_CORE://ExceptionHandler/ERROR_OBJECT";
  ExceptionHandlerSituationType2["PARAMETER"] = "SIMPLE_BOOT_CORE://ExceptionHandler/PARAMETER";
  return ExceptionHandlerSituationType2;
})(ExceptionHandlerSituationType || {});
const ExceptionHandlerMetadataKey = Symbol.for("simple-boot:exception-handler-metadata");
const ExceptionHandler = (config = {}) => {
  return (target, propertyKey, descriptor) => {
    const saveMappingConfigs = ReflectUtils.getMetadata(ExceptionHandlerMetadataKey, target.constructor) ?? [];
    const method = target[propertyKey];
    saveMappingConfigs.push({ propertyKey, method, config });
    ReflectUtils.defineMetadata(ExceptionHandlerMetadataKey, saveMappingConfigs, target.constructor);
    ReflectUtils.defineMetadata(ExceptionHandlerMetadataKey, config, target, propertyKey);
  };
};
const getExceptionHandler = (target, propertyKey) => {
  return ReflectUtils.getMetadata(ExceptionHandlerMetadataKey, target, propertyKey);
};
const getExceptionHandlers = (target) => {
  if (target !== null && void 0 !== target && typeof target === "object") {
    target = target.constructor;
  }
  return ReflectUtils.getMetadata(ExceptionHandlerMetadataKey, target);
};
const targetExceptionHandlers = (target, error) => {
  const exceptionHandlers = getExceptionHandlers(target);
  const emptyTargets = exceptionHandlers?.filter((it) => it.config.type === void 0);
  const targets = exceptionHandlers?.filter((it) => ObjectUtils.isPrototypeOfTarget(it.config.type, error));
  const targetSorts = targets?.sort((a, b) => {
    const aPrototypeOfDepth = ObjectUtils.prototypeOfDepth(error, a.config.type);
    const bPrototypeOfDepth = ObjectUtils.prototypeOfDepth(error, b.config.type);
    return aPrototypeOfDepth.length - bPrototypeOfDepth.length;
  });
  return (targetSorts ?? []).concat(...emptyTargets ?? []);
};
const targetExceptionHandler = (target, error, excludeMethods = []) => {
  let exceptionHandlers = targetExceptionHandlers(target, error);
  exceptionHandlers = exceptionHandlers?.filter((it) => !excludeMethods.includes(it.method));
  if (exceptionHandlers && exceptionHandlers.length > 0) {
    return exceptionHandlers[0];
  } else {
    return void 0;
  }
};
const exceptionHandler = ExceptionHandler;
export {
  ExceptionHandler,
  ExceptionHandlerSituationType,
  exceptionHandler,
  getExceptionHandler,
  getExceptionHandlers,
  targetExceptionHandler,
  targetExceptionHandlers
};
//# sourceMappingURL=ExceptionDecorator.js.map
